export function WatchIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="none"
        viewBox="0 0 14 14"
      >
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 10.5c3.222 0 5.833-3.5 5.833-3.5S10.222 3.5 7 3.5 1.167 7 1.167 7 3.778 10.5 7 10.5z"
        ></path>
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 8.167a1.167 1.167 0 100-2.334 1.167 1.167 0 000 2.334z"
        ></path>
      </svg>
    );
  }

  